import {
    RadioScheduleChannels,
    TVScheduleChannels,
} from "../../types/Channels";

import {
    DEFAULT_SCHEDULE_CHANNEL_ID,
    COJP_DEFAULT_SCHEDULE_CHANNEL_ID,
    AUDIO_CHANNELS,
    RAW_CHANNELS,
    RADIO_CHANNEL_PREFERENCE_KEY,
} from "./channels";

const RADIO_SCHEDULE_CHANNELS: RadioScheduleChannels[] = [
    "newyork",
    "boston",
    "dc",
    "national",
];
const DEFAULT_AUDIO_SCHEDULE_CHANNEL_ID = "national";
const TV_SCHEDULE_CHANNELS: TVScheduleChannels[] = [
    "us",
    "europe",
    "asia",
    "australia",
];

const LIVE_SCHEDULE_HOURS = 12;
const TV_SCHEDULE_HOURS = 24 * 7;
export {
    LIVE_SCHEDULE_HOURS,
    TV_SCHEDULE_HOURS,
    TV_SCHEDULE_CHANNELS,
    RADIO_SCHEDULE_CHANNELS,
    DEFAULT_AUDIO_SCHEDULE_CHANNEL_ID,
    DEFAULT_SCHEDULE_CHANNEL_ID,
    COJP_DEFAULT_SCHEDULE_CHANNEL_ID,
    AUDIO_CHANNELS,
    RAW_CHANNELS,
    RADIO_CHANNEL_PREFERENCE_KEY,
};

export default {
    LIVE_SCHEDULE_HOURS,
    TV_SCHEDULE_HOURS,
    TV_SCHEDULE_CHANNELS,
    RADIO_SCHEDULE_CHANNELS,
    DEFAULT_AUDIO_SCHEDULE_CHANNEL_ID,
    DEFAULT_SCHEDULE_CHANNEL_ID,
    COJP_DEFAULT_SCHEDULE_CHANNEL_ID,
    AUDIO_CHANNELS,
    RAW_CHANNELS,
    RADIO_CHANNEL_PREFERENCE_KEY,
};
